import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { Colors } from 'library';
import { Close, Redeem } from '@mui/icons-material';
import { IconButton, Link, Row, Text } from 'library/ui';
import { Banner, useBannerSlot } from 'parent-portal/navigation';
import { ReferralModal } from 'parent-portal/navigation/ReferralModal';

export function ReferralBanner({ small, setShowRefer }: { small: boolean; setShowRefer: (show: boolean) => void }) {
    const [open, setOpen] = useState<boolean>(false);
    const slot = useBannerSlot();

    const bannerNode = (
        <Banner variant="accent" action={<IconButton icon={Close} onClick={() => setShowRefer(false)} />}>
            <Row gap="sm">
                <Redeem style={{ color: Colors.accent, fontSize: 20 }} />
                <Text tone="inherit" weight="bold">
                    Loving Tandem?
                </Text>
                <Link onClick={() => setOpen(true)}>Refer a center and you both get $50!</Link>
            </Row>
        </Banner>
    );

    return (
        <>
            {slot && ReactDOM.createPortal(bannerNode, slot)}
            <ReferralModal isOpen={open} onClose={() => setOpen(false)} small={small} />
        </>
    );
}
